<template>
  <div v-if="dadosEmprestimo.vigente">
    <Titulo :title="titulo" />
    <div v-if="dadosEmprestimo.active_emprestimo" class="container-filho">
      <div class="mdl-card__supporting-text grid-layout-emprestimo">
        <div style="align-self: center;">
          <h6 class="m-auto center-items m-0">Total Pago</h6>
          <div style="position: relative; margin: auto 0;">
            <GraficoEmprestimoCircular class="canvas_grafico_doughnut grafico-emprestimo"
              :dados="dadosEmprestimo.grafico" />
            <div class="info-center">
              <span>{{ dadosEmprestimo.grafico.data }}%</span>
            </div>
          </div>
        </div>
        <div class="card-values-emprestimo">
          <div class="card-emprestimo-value">
            <template v-for="item in dadosEmprestimo.tabela">
              <div class="value-emp" v-if="!isNaN(item.value)">
                <p class="title">{{ item.name }}</p>
                <p>R$<span :style="item.color">{{ formatMoeda(item.value, false) }}</span></p>
              </div>
              <div class="value-emp" v-else>
                <p class="title">{{ item.name }}</p>
                <p><span :style="item.color">{{ item.value }}</span></p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!dadosEmprestimo.active_emprestimo">
      <p>Você tem limite pré-aprovado de {{ dadosEmprestimo.disponivel }} conosco!
        Vamos simular seu empréstimo agora?
      </p>
    </div>
    <div v-if="btn_acao">
      <MiniCardAcao v-if="contratacaoEmp" :texto="'Você tem uma solicitação de empréstimo em avaliação. Veja aqui.'"
        :router="'/emprestimo'" />
      <MiniCardAcao v-if="!contratacaoEmp && dadosEmprestimo.active_emprestimo"
        :texto="'Acompanhe aqui o histórico do seu empréstimo'" :router="'/historicoemprestimo'" />
      <MiniCardAcao v-if="!contratacaoEmp && (!dadosEmprestimo.active_emprestimo || refinanciamentoLiberado)"
        :texto="textoMiniCard3" :router="'/emprestimo'" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Titulo from './Titulo.vue'
import GraficoEmprestimoCircular from './GraficoEmprestimoCircular.vue'
import FirebaseHelper from "@/service/FirebaseHelper";
import MiniCardAcao from './MiniCardAcao.vue'
const financeiro = require('../../functions/geral/Financeiro')

export default {
  components: {
    Titulo,
    GraficoEmprestimoCircular,
    MiniCardAcao
  },
  props: {
    titulo: "",
    btn_acao: true,
    contratacao_emp: {}
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      login: "login",
      chave: "chave",
      cpf: "cpf",
      uid: "uid",
      plano: "plano"
    }),
  },
  data() {
    return {
      dadosEmprestimo: {
        active_emprestimo: false, 
        disponivel: 0,
        grafico: {},
        tabela: [],
        vigente: false,
      },
      contratacaoEmp: '',
      refinanciamentoLiberado: false,
      firebaseHelper: new FirebaseHelper(),
      textoMiniCard3: ''
    }
  },
  async created() {   
    this.dadosEmprestimo = this.participante.projetoVida.emprestimo
    this.dadosEmprestimo.disponivel = financeiro.valorFormatoDesc(this.dadosEmprestimo.disponivel, true)
    if (this.dadosEmprestimo.disponivel > 0) {
      this.textoMiniCard3 = `Temos uma oportunidade especial!
          Que tal um empréstimo de ${this.dadosEmprestimo.disponivel}?`
    }
    this.contratacaoEmp = this.contratacao_emp    
    let ret = await this.firebaseHelper.getDadosSimuladorEmprestimo(this.participante, this.uid)    
    if (ret) {
      this.refinanciamentoLiberado = (
        !ret.bloqueio &&
        !ret.bloqueio_saldoInsuficiente &&
        !ret.bloqueio_emprestimoRecente &&
        Number(this.dadosEmprestimo.disponivel) > 500
      )
    }
  },
  methods: {
    formatMoeda(value, incluiCifrao) {
      if (value === 0) {
        return '(não contratado)'
      } else if (value && value !== 0) {
        let val = financeiro.valor_to_string_formatado(value, 2, incluiCifrao, true)
        return val
      }
    }
  },
}
</script>

<style scoped>
.m-0 {
  margin: 0;
}

.value-emp {
  border-bottom: 1px solid #ccc;
}

.value-emp:last-child {
  border-bottom: none;
}

.value-emp {
  padding: 10px;
}

.card-emprestimo-value {
  padding: 10px;
  border-radius: 30px;
}

.value-emp .title {
  font-weight: 600;
  margin: 0px;
}

.value-emp p span {
  font-size: 16px;
  font-weight: 800;
  vertical-align: top;
  line-height: 20px;
  margin-left: 3px;
}

.value-emp p {
  margin-top: 5px;
  margin-bottom: 0px;
}

.info-center {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  line-height: 25px;
  width: 100%;
  text-align: center;
}

.info-center span {
  font-size: 25px;
  font-weight: 600;
  color: rgb(53, 53, 53);
  padding-left: 10px;
}

.card-values-emprestimo {
  width: 100%;
  align-self: center;
}

.grid-layout-emprestimo {
  width: 100%;
  margin: auto;
}

.grafico-emprestimo {
  width: 100%;
}

.bar-grafico {
  background: #d0d0d0;
  min-height: 300px;
  width: 100%;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
}

.bar-grafico div {
  width: 100%;
  background: #0C7BC6;
  position: absolute;
  bottom: 0;
  border-radius: 50px;
  text-align: center;
}

.bar-grafico div span {
  color: white;
  font-weight: 900;
  font-size: 20px;
}

.fixed-in-center {
  position: absolute;
  margin-top: -75%;
  text-align: center;
  left: 10%;
}

p.textoModal {
  line-height: 18px;
  text-align: left;
  font-size: 16px;
  font-family: 'MaisFuturo-Medium';
  letter-spacing: 0px;
  color: #131721;
  opacity: 1;
  margin-bottom: 2px !important;
}

p.textoModal2 {
  line-height: 18px;
  text-align: left;
  font-size: 16px;
  font-family: 'MaisFuturo-Regular';
  letter-spacing: 0px;
  color: #131721;
  opacity: 1;
  margin-bottom: 2px !important;
}

@media screen and (min-width: 479px) {
  .grid-layout-emprestimo {
    display: grid;
    grid-template-columns: 45% 45%;
    column-gap: 10%;
  }
}

@media screen and (max-width: 479px) {
  .grid-layout-emprestimo {
    display: grid;
    grid-template-columns: 40% 60%;
  }
}</style>
